<h2 mat-dialog-title>Adding unit converter</h2>
<form [formGroup]="form">
  <mat-dialog-content class="parameter-fields-container">
    <mat-form-field>
      <mat-label>Unit name (max 10 characters)</mat-label>
      <input
        matInput
        formControlName="unit"
        (input)="onUnitInputChange()"
        name="unit"
      />
      @if(form.controls.unit.hasError('maxlength')){
      <mat-error>{{ "Maximum number of characters is 10" }}</mat-error>
      } @if(form.controls.unit.hasError('pattern') &&
      form.controls.unit.value){
      <mat-error>{{ "Invalid characters" }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Factor (max 10 characters)</mat-label>
      <input
        matInput
        formControlName="factor"
        name="factor"
      />
      @if(form.controls.factor.hasError('maxlength')){
      <mat-error>{{ "Maximum number of characters is 10" }}</mat-error>
      } @if(form.controls.factor.hasError('pattern') &&
      form.controls.factor.value){
      <mat-error>{{ "Invalid characters" }}</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button
      mat-button
      cdkFocusInitial
      (click)="onAddClick()"
      [disabled]="!isFormValid()"
    >
      Add
    </button>
  </mat-dialog-actions>
</form>

